import { useEffect, useState } from "react"
import { Modal, ModalId, useUIState } from "../../../../../features/ui"
import { DiscountForm } from "./discountForm"
import { Discount } from "../../../types"

type Props = {
    defaultData?: Partial<Discount>
    usedNames: string[]
    onSubmit: (data: Partial<Discount>) => void
}

export const DiscountFormModal = (props: Props) => {
    const { defaultData, usedNames, onSubmit } = props
    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()

    useEffect(() => {
        setKey(key + 1)
    }, [openedModal])
    
    return (
        <Modal
            modalId={ModalId.DISCOUNT_FORM}
            title="Agregar Bonificación"
            actions={[]}
        >
            <DiscountForm
                key={key}
                defaultData={defaultData}
                usedNames={usedNames}
                onSubmit={onSubmit}
            />
        </Modal>
    )
}
